import { createSelector } from '@reduxjs/toolkit'
import { getCollectionOrEmptyObject } from '@opallabs/lambda'
import { Content, Moment, Phase, Service } from '../../../../types'
import { getContent } from '../../getters/entities/content'
import { getMoments } from '../../getters/entities/moments'
import { getPhases } from '../../getters/entities/phases'
import { getServices } from '../../getters/entities/services'
import { mapPhaseItemsToNormalizedAssignments } from '../../utils'
import { selectPhaseItems } from './phaseItems'

export const selectPhases = createSelector([getPhases], (phases) =>
  getCollectionOrEmptyObject<Phase>(phases)
)

export const selectContents = createSelector([getContent], (contents) =>
  getCollectionOrEmptyObject<Content>(contents)
)

export const selectMoments = createSelector([getMoments], (moments) =>
  getCollectionOrEmptyObject<Moment>(moments)
)

export const selectServices = createSelector([getServices], (services) =>
  getCollectionOrEmptyObject<Service>(services)
)

export const selectNormalizedPhaseItems = createSelector(
  [selectPhaseItems, selectPhases, selectContents, selectServices],
  (phaseItems, phases, contents, services) =>
    mapPhaseItemsToNormalizedAssignments({
      phaseItems,
      phases,
      contents,
      services,
    })
)
